import { IServerSideGetRowsParams } from 'ag-grid-community';
import { GridColumn } from '../api/endpoints';
import union from 'lodash/union';

type GetRequestColumnsParams = {
  params: IServerSideGetRowsParams;
  gridColumns?: GridColumn[];
  requiredColumns?: string[];
  allColumns?: boolean;
};

export function getRequestColumns({
  params,
  gridColumns,
  requiredColumns,
  allColumns,
}: GetRequestColumnsParams) {
  // Generate a GraphQL query based on column properties
  const columns: string[] = [...(gridColumns || [])]
    .sort((a, b) => a?.id - b?.id)
    .map((c) => (c.subProperty ? '' : c.propertyName))
    .filter((c) => c !== '');

  const displayedColumns = params.columnApi
    ?.getAllDisplayedColumns()
    .map((c) => c.getColId())
    .filter((col) => columns.includes(col));

  const requestColumns = allColumns
    ? union(displayedColumns, columns)
    : displayedColumns;

  gridColumns?.forEach((c) => {
    if (c.subProperty) {
      requestColumns.push(`${c.propertyName} { ${c.subProperty} }`);
    }
  });

  return requiredColumns ? union(requestColumns, requiredColumns) : requestColumns;
}
